import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Clickable, Icon, Layout, Text } from 'ds';
import { AI_ASSISTANT_PATH } from 'routes';
import { actions } from 'store/AIAssistant';
import { useAppDispatch } from 'store/hooks';
import { useAppSelector } from 'store/hooks';
import { selectTenancyId } from 'store/v2/User/selectors';

import { WidgetVariant } from './types';
import { postToConversation, startConversation } from '../AIAssistant/requests';
import { SUGGESTED_AI_ASSISTANT_PROMPTS } from '../constants';

interface Props {
  variant: WidgetVariant;
}

const TellCodiWidget: React.FC<Props> = ({ variant = 'full' }) => {
  const [prompt, setPrompt] = useState<string>();
  const tenancyId = useAppSelector(selectTenancyId);

  useEffect(() => {
    setPrompt(SUGGESTED_AI_ASSISTANT_PROMPTS[Math.floor(Math.random() * SUGGESTED_AI_ASSISTANT_PROMPTS.length)]);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const dispatch = useAppDispatch();
  const history = useHistory();

  if (!tenancyId || !prompt) return null;

  const handleMessage = async ({ conversationId, input }: { conversationId: number; input: string }) => {
    const { data: conversation } = await postToConversation({
      tenancyId,
      conversationId: conversationId,
      message: input
    });
    dispatch(actions.removePendingConversationMessage({ conversationId }));
    dispatch(actions.updateConversation({ conversation }));
  };

  const handlePromptCardClick = async () => {
    const { data } = await startConversation(tenancyId);
    dispatch(actions.addConversation(data));
    dispatch(actions.addPendingConversationMessage({ conversationId: data.id, input: prompt }));
    handleMessage({ conversationId: data.id, input: prompt });
    setTimeout(() => {
      history.push(`${AI_ASSISTANT_PATH}/${data.id}`);
    }, 700);
  };

  if (variant === 'half') {
    return (
      <Clickable onClick={handlePromptCardClick} fullWidth fullHeight>
        <Layout
          color="purple-gradient-transparent"
          borderRadius={16}
          padding={12}
          height="100%"
          direction="column"
          justify="center"
          gap={4}
        >
          <Layout direction="column" gap={4}>
            <Layout direction="row" gap={4} align="center">
              <Icon name="sparkle" color="purple-gradient" size={20} />
              <Text size="overline-sm" color="purple-gradient" align="left">
                TELL CODI
              </Text>
            </Layout>
            <Text size="body-sm" color="purple-gradient" semibold align="left">
              {prompt}
            </Text>
          </Layout>
        </Layout>
      </Clickable>
    );
  }

  return (
    <Clickable onClick={handlePromptCardClick} fullWidth fullHeight>
      <Layout
        color="purple-gradient-transparent"
        borderRadius={16}
        padding={16}
        height="100%"
        direction="column"
        justify="center"
        gap={4}
      >
        <Icon name="sparkle" color="purple-gradient" size={32} />
        <Text size="overline-sm" color="purple-gradient" align="left">
          TELL CODI
        </Text>
        <Text size="headline-xs" color="purple-gradient" align="left">
          {prompt}
        </Text>
      </Layout>
    </Clickable>
  );
};

export default TellCodiWidget;
